import anime from 'animejs';
import isElementInViewport from '../in-viewport';
import config from '../config';

$(() => {
    const $els = $('.inview-animation');

    $els.each((i, el) => {
        let isElInView = false;
        const inViewOffset = $(el).attr('data-inview') || 0.1;
        // init animation
        const animeSel = '.inview-anime';
        const $animeEls = $(el).find(animeSel);
        const animeTimeline = anime.timeline({
            duration: config.animateTime.textIn,
            autoplay: false,
            easing: config.animeEasing.easingTextIn,
        });
        $animeEls.each((_, animeEl) => {
            const transform =
                $(animeEl).attr('data-anime-transform') !== 'false'
                    ? $(animeEl).attr('data-anime-transform') || 'translateY'
                    : false;
            const translate = Number($(animeEl).attr('data-anime-translate')) || 32;
            let timeOffset = Number($(animeEl).attr('data-anime-timeline')) || 0;
            timeOffset *= config.animateTime.textIn;
            let translateX = 0;
            let translateY = 0;
            if (transform) {
                switch (transform) {
                    case 'translateX':
                        translateX = translate;
                        break;
                    case 'translateY':
                        translateY = translate;
                        break;
                    default:
                        break;
                }
            }
            animeTimeline.add(
                {
                    targets: animeEl,
                    opacity: [0, 1],
                    translateX: [translateX, 0],
                    translateY: [translateY, 0],
                },
                timeOffset
            );
        });

        function scrollToViewport() {
            if (isElementInViewport(el, inViewOffset) && !isElInView) {
                isElInView = true;
                animeTimeline.play();
                window.removeEventListener('scroll', scrollToViewport);
            }
        }
        scrollToViewport();
        window.addEventListener('scroll', scrollToViewport);
    });
});
